import Constants from "expo-constants";

/* App version */
export const APP_VERSION = Constants?.manifest?.version || "2.2.3";
